/**
 * Sonmol cart upsell — ajoute le produit upsell au panier en AJAX
 * et rafraîchit le drawer sans le fermer.
 *
 * Pattern : event delegation sur document — fonctionne même quand
 * le drawer rerender son contenu après chaque update.
 */

(function () {
  'use strict';

  const SECTION_IDS = ['cart-drawer', 'cart-icon-bubble'];

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('.sonmol-cart-upsell__add');
    if (!button || button.disabled) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const originalLabel = button.querySelector('span:last-child').textContent;
    button.disabled = true;
    button.querySelector('span:last-child').textContent = 'Ajout…';

    try {
      const response = await fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          sections: SECTION_IDS,
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();

      // Notifier les Web Components Dawn pour qu'ils rafraîchissent leur contenu
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        // Nettoyer is-empty (sinon Dawn masque les items via CSS)
        if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(data);
      } else {
        // Fallback : reload léger
        renderSections(data);
      }

      button.querySelector('span:last-child').textContent = '✓ Ajouté';
      setTimeout(() => {
        button.querySelector('span:last-child').textContent = originalLabel;
        button.disabled = false;
      }, 1200);
    } catch (err) {
      console.error('Sonmol upsell add error:', err);
      button.querySelector('span:last-child').textContent = originalLabel;
      button.disabled = false;
    }
  });

  function renderSections(parsedState) {
    if (!parsedState || !parsedState.sections) return;
    Object.entries(parsedState.sections).forEach(([sectionId, html]) => {
      const target = document.getElementById(sectionId);
      if (!target) return;
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContent = doc.getElementById(sectionId);
      if (newContent) target.innerHTML = newContent.innerHTML;
    });
  }
})();
